import HTTP from '../HTTP';

const BASE_URL = 'ImageConnexion';
const PROJET_NAME = 'AALV';

export default async function getImageConnexion() {
  const response = await HTTP.get(BASE_URL + '/GetPieceJointeImageConnexionAsync/' + PROJET_NAME);
  return response;
}



// WEBPACK FOOTER //
// ./src/api/imageConnexion/index.js